import React from 'react'
import styled from 'styled-components'

/**
 * Allows the user to quickly delete an announcement by clicking on it.
 * 
 * @author Alex Clary
 * 
 * @param {Array} announcements all announcements
 * @param {Function} deleteAnnouncement a redux-thunk-connected function that deletes an announcement
 * 
 * TODO: Delete this and replace with a more full-featured editing component?
 */
const DeleteAnnouncementsSection = ({ announcements, deleteAnnouncement }) =>
  <section className='delete-announcements-section'>
    <h2>Delete Active Announcements</h2>
    {announcements.length === 0 && 'No active announcements.'}
    {announcements.sort((a, b) => b.beginDate - a.beginDate).map(announcement =>
      <button type='button' key={announcement.id} onClick={() => deleteAnnouncement(announcement.id)}>Delete "{announcement.headline}"</button>)}
  </section>

export default styled(DeleteAnnouncementsSection)`
  margin-top: 5rem;
`